import { CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
export const EXTERNAL_LINK = 'https://www.yamaha-motor.eu?dealerID=10082018';
export const INTERNAL_LINK = '/nl/nl/test?dealerID=10082018';
export const MOCK_BUTTON_PROPS = {
    isRightToLeft: false,
    buttonLabel: 'button label',
    buttonTitle: 'button title',
    buttonWidth: 'auto',
    size: SIZE_44,
    buttonLink: INTERNAL_LINK,
    buttonVariant: CONTAINED_VARIANT,
    hasIconButton: NO_ICON,
    className: '',
};
export const MOCK_BUTTON_WRAPPER_PROPS = {
    buttonLink: INTERNAL_LINK,
    onClick: () => { },
};
